module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/big/42-20a48c94017763f313374445afd61909.webp";